import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("username");
    if (!user) {
      navigate("/login", { replace: true });  // Go to login if not logged in
    }
  }, [navigate]);
};

export default useAuthRedirect;
